import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import {FiExternalLink} from "react-icons/fi";


function FreeGiftList(props) {
    //@ts-ignore
    const availableGifts = useSelector((state)=>state.settings.gifts)
    //@ts-ignore
    const meta = useSelector((state)=>state.settings.metadata);
    const parsed = meta ? JSON.parse(meta) : {}
    const {gift_redemptions} = parsed
    return (
        <div className={"d-flex flex-column gap-2"}>
            {
                availableGifts?.map((i)=>{
                    const redemption = gift_redemptions && gift_redemptions.find(j=>j.giftId === i.id)
                    return <div className={"card"} key={String(i.id)}>
                        <div className="card-body">
                            <RenderFreeGiftCard redemption={redemption} gift={i}/>
                        </div>
                    </div>
                })
            }
        </div>
    );
}


function RenderFreeGiftCard({gift, redemption}: { redemption:{name: string, statusPageUrl: string}, gift: GiftObject }) {
    const image =
        gift && gift.products && gift.products.length > 0 &&
        gift?.products[0]?.images && gift?.products[0]?.images[0] && gift?.products[0]?.images[0].url
    const [max, setMax] = useState(3)
    return (
        <div>
            <div className="d-flex justify-content-between gap-2">
                <div className="d-flex gap-3">
                    <img src={image || 'https://placehold.co/64'} alt={""} style={{width: 64, height: 64, objectFit: 'cover'}}
                         className={"rounded border shadow-sm"}/>
                    <div>
                        <h5 className={"mb-0"}>{gift.title}</h5>
                        <Subtitle gift={gift}/>
                        {
                            gift.products.length > 0 ? gift.products
                                .slice(0, max)
                                .map((i, index) => {
                                    return <ProductItem key={String(index)} item={i}/>
                                }) : null
                        }
                        {
                            gift.products.length > max ? <div className={"text-muted"}>
                                <button
                                    onClick={() => setMax(gift.products.length)}
                                    className={"btn btn-link text-sm"}>View {gift.products.length - 3} more
                                </button>
                            </div> : null
                        }
                    </div>

                </div>
                <div className={"d-flex  align-items-end flex-column gap-2"}>
                    {
                        redemption ? <React.Fragment>
                                <span className="badge badge-success">
                                    <FormattedMessage id={"Redeemed"} />
                                </span>
                                <a href={redemption?.statusPageUrl}
                                   className={"d-inline-flex align-items-center gap-1"}
                                   target={"_blank"}>Track <FiExternalLink/></a>
                            </React.Fragment>

                            :
                            <Link to={`/gift/${gift.id}`} className={"btn btn-link"}>
                                <FormattedMessage id={"Redeem"}/>
                            </Link>
                    }

                </div>
            </div>
        </div>
    )
}

function ProductItem({item}: { item: ProductGiftItem }) {
    const image = item.images && item.images[0]
    return <div className={"d-flex align-items-center mt-3 gap-2"}>
        <img src={image?.url || 'https://placehold.co/64'} alt={""}
             className={"border rounded shadow-sm"}
             style={{width: 64, height: 64, objectFit: 'cover'}}/>
        <span className="text-muted line-clamp-3" style={{maxWidth:460}}>
                {item.name}
         </span>
    </div>
}

function Subtitle({gift}) {
    return <div>
        {
            gift.maxProducts && Number(gift.maxProducts) < gift.products.length ?
                <FormattedMessage id={"free_gift_choose"}
                                  defaultMessage={`Choose {num, plural, one {a free product} other {{num} free products}}`}
                                  values={{
                                      num: gift.maxProducts
                                  }}/>
                :
                <FormattedMessage id={"free_gift_all"}  defaultMessage={`Enjoy {num, plural, one {a free product} other {{num} free products}}`}
                                  values={{
                                      num: gift.maxProducts
                                  }}/>
        }

    </div>
}

export default FreeGiftList;
